<label for="feature_{{feature.id}}">
  {{ feature.header }}@if (feature.unitHeader) {<span>, {{ feature.unitHeader }}</span>}
  @if (isRequired()) {<span> *</span>}
  @if (feature.comment) {<span nbTooltip="{{feature.comment}}"><tui-icon icon="lightbulb"/></span>}
</label>

<div class="accordion-item__right">
  <div class="accordion-item__select accordion-item__select-custom">
    <form [formGroup]="form">
      <ng-select [items]="featureValues"
                 [multiple]="isMultiple()"
                 [closeOnSelect]="!isMultiple()"
                 [hideSelected]="true"
                 [loading]="loading"
                 #select
                 (blur)="onBlur($event)"
                 formControlName="featureValue"
                 id="feature_{{feature.id}}"
                 placeholder="Классификатор"
                 i18n-placeholder="@@TemplateClassifierLabel"
                 appendTo="body"
                 bindLabel="value"
                 bindValue="id">
        <ng-template ng-multi-label-tmp let-items="items" let-clear="clear">
          @for (item of items | slice:0:showItemsCount; track item) {
            <div class="ng-value">
              <span class="ng-value-label">{{ $any(item).value }}</span>
              <span class="ng-value-icon right" (click)="clear(item)" aria-hidden="true">×</span>
            </div>
          }
          @if (showAllSelectedValuesButton(items.length)) {
            <div class="ng-value">
              <span i18n="@@EscheZnacheniy" class="ng-value-icon" aria-hidden="true" (click)="showAllSelectedValues(select)">Еще {{ getHiddenSelectedItemsCount(items.length) }} значений...</span>
            </div>
          }
          @if (showHideButton(items.length)) {
            <div class="ng-value">
              <span class="ng-value-icon" aria-hidden="true" (click)="hideExtraSelectedValues()" i18n="@@HideExtraSelectedValuesButton">Скрыть значения</span>
            </div>
          }
        </ng-template>
      </ng-select>

      @if (isMultiple() && featureValue.invalid && (featureValue.dirty || featureValue.touched)) {
        <div>
          @if (featureValue.hasError('required')) {
            <div class="text-danger" i18n="@@FeatureValueRequiredError">
              Поле обязательно для заполнения
            </div>
          }
          @if (featureValue.hasError('minlength')) {
            <div class="text-danger" i18n="@@FeatureValueMinLengthError">
              Минимум {{ featureValue.errors.minlength.requiredLength }} значений
            </div>
          }
          @if (featureValue.hasError('maxlength')) {
            <div class="text-danger" i18n="@@FeatureValueMaxLengthError">
              Превышен лимит выбранных значений: {{ featureValue.errors.maxlength.actualLength }} из {{ featureValue.errors.maxlength.requiredLength }}
            </div>
          }
        </div>
      }
    </form>
  </div>
  <div class="accordion-item__right-info">
    @if (feature.fromMasterCard) {
      <div class="state-master-card" i18n-nbTooltip="@@FeatureFromMasterCard" nbTooltip="Характеристика заполнена из мастер карты">
        <tui-icon icon="credit-card"/>
      </div>
    }
    @if (featureValue.valid && isShowEmptyWarning()) {
      <div class="state-warn">
        <tui-icon icon="triangle-alert"/>
      </div>
    }
    @if (featureValue.invalid) {
      <div class="state-err">
        <tui-icon icon="circle-alert"/>
      </div>
    }
    @if (featureValue.valid && !isEmpty()) {
      <div class="state-success">
        <tui-icon icon="check"/>
      </div>
    }

    @if (featureLink) {
      <a [routerLink]="['/cabinet/pim/feature/edit/', feature.featureId]"
         class="entityID"
         target="_blank"
         i18n-nbTooltip="@@OpenFeatureInNewWindow"
         nbTooltip="Открыть характеристику в новом окне">
        #{{ feature.featureId }}
      </a>
    }
    @if (showRemoveButton) {
      <button nbButton ghost size="tiny" status="danger" (click)="removeEvent.emit()" nbTooltip="Удалить характеристику МК" i18n-nbTooltip="@@DeleteMasterCardFeature">
        <tui-icon icon="trash-2"/>
      </button>
    }
  </div>
</div>
